import React, { Component, Fragment } from 'react';
import { t, jt } from 'ttag';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import AlertBox from './alertBox';
import Price from '../../utils/prices';
import InfoIcon from '../icons/InfoIcon';
import { unisportDiscount, standardDiscount } from '../discounts';

const alertMessage = (props) => {
  return <Fragment>{props.msg}</Fragment>;
};

class TotalContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      discountMsg: false,
    };
    this.handleCloseDiscountInfo = this.handleCloseDiscountInfo.bind(this);
  }

  handleClick = () => {
    this.props.submitOrder();
  }

  toggleAlert = () => {
    this.props.toggleAlert();
  }

  getDeliveryDays = () => {
    let deliveryDaysTotal = '';
    switch (this.props.settings.locale) {
      case 'nl': // Netherland
        deliveryDaysTotal = '5 - 21';
        return deliveryDaysTotal;
      case 'fi': // Finland
        deliveryDaysTotal = '5 - 21';
        return deliveryDaysTotal;
      case 'de-AT': // Austria
        deliveryDaysTotal = '4 - 20';
        return deliveryDaysTotal;
      case 'da': // Denmark
        deliveryDaysTotal = '3 - 19';
        return deliveryDaysTotal;
      case 'fr': // France
        deliveryDaysTotal = '3 - 20';
        return deliveryDaysTotal;
      case 'nb': // Norway
        deliveryDaysTotal = '3 - 20';
        return deliveryDaysTotal;
      case 'sv': // Sweden
        deliveryDaysTotal = '3 - 19';
        return deliveryDaysTotal;
      case 'de': // Germany
        deliveryDaysTotal = '3 - 19';
        return deliveryDaysTotal;
      case 'en': // International
        deliveryDaysTotal = '6 - 22';
        return deliveryDaysTotal;
      default:
        deliveryDaysTotal = '3 - 19';
        return deliveryDaysTotal;
    }
  }

  handleDiscountInfo() {
    this.setState({ discountMsg: true });
    this.toggleAlert('discountInfo');
  }

  handleCloseDiscountInfo() {
    this.setState({ discountMsg: false });
  }

  render() {
    let discountAmount = this.props.discount ? `- ${this.props.discount}` : '- 0 %';
    if (this.props.costumizationToggleItems.unisport) discountAmount = `- ${unisportDiscount}`;

    const popupTrans = {
      step1: t`Your order must contain at least 1 piece, before you can continue with the order.`,
      step2: t`Your order must contain at least 1 piece, before you can continue with the order. Choosing more pieces than available in stock is not possible.`,
      step3: jt`To be eligble for the ${unisportDiscount} discount related to Unisport print, you must choose to purchase shirts.`,
      discountInfo: jt`TeamSport (${standardDiscount}) discount or Unisport Sponsorship (${unisportDiscount}) discount are not applied on products in sale.`,
    };

    let msg = '';
    let alertType = '';
    let propName = '';
    switch (this.props.totalContainerLink) {
      case '/amount/':
        if (this.state.discountMsg) {
          msg = popupTrans.discountInfo;
        } else {
          msg = popupTrans.step1;
          alertType = 'color';
        }
        propName = this.props.colorCanContinue;
        break;
      case '/print/':
        if (this.state.discountMsg) {
          msg = popupTrans.discountInfo;
        } else {
          msg = popupTrans.step2;
          alertType = 'amount';
        }
        propName = this.props.sizeCanContinue;
        break;
      case '/revieworder/':
        if (this.state.discountMsg) {
          msg = popupTrans.discountInfo;
        } else {
          msg = popupTrans.step3;
          alertType = 'unisport';
        }
        propName = this.props.colorCanContinue && this.props.sizeCanContinue;
        break;
      default:
        if (this.state.discountMsg) {
          msg = popupTrans.discountInfo;
        } else {
          msg = popupTrans.step1;
          alertType = 'unisport';
        }
        propName = this.props.colorCanContinue && this.props.sizeCanContinue;
      break;
    }

    const total = new Price(this.props.total.total, this.props.settings.currency);
    const totalDiscount = new Price(this.props.total.discount, this.props.settings.currency);

    return (
      <div className={`totalContainer ${this.props.totalContainerSticky ? 'sticky' : null}`}>
        <div className="totalInner">
          <div className="totalInnerContainer">
            <div className="priceHolder totalHolder">
              <span className="totalText">{this.props.generalTranslations.Total}</span>
              <span className="total">
              {total.toString()}
              </span>
              <button type="button" className="info-cta cta-mobile" onClick={() => this.handleDiscountInfo()}><InfoIcon /></button>
            </div>
            <div className="priceHolder">
              <span>{this.props.generalTranslations.TotalDiscount}</span>
              <span className="sub_total">{ discountAmount }</span>
              <div>
                <button type="button" className="info-cta" onClick={() => this.handleDiscountInfo()}><InfoIcon /></button>
                <span className="sub_total">
                  {totalDiscount.toString()}
                </span>
              </div>
            </div>
            <hr />
            <div className="deliveryHolder">
              <span>{this.props.generalTranslations.EstimatedDeliveryTime}</span>
              <span className="deliveryTime">
                {`${this.getDeliveryDays()} ${this.props.generalTranslations.Days}`}
              </span>
            </div>
          </div>

          {this.props.OrangeButton ?
              <div
                onClick={() => this.handleClick()}
                className="continueBtn secondary"
                role="button"
                tabIndex="0"
                style={{ outline: 'none' }}
              >
                <span>{this.props.totalContainerLinkText}</span>
                <span className="icon-direction-white-right" />
              </div>
            :
            <div className="btnHolder">
                <div>
                  {propName ?
                    <NavLink to={this.props.totalContainerLink} className="continueBtn ">
                      <span>{this.props.totalContainerLinkText}</span>
                      <span className="rightarrow" />
                    </NavLink>
                    :
                    <div className="continueBtn" onClick={() => this.toggleAlert(`${alertType}`)} role="button" tabIndex="0">
                      <span>{this.props.totalContainerLinkText}</span>
                      <span className="rightarrow" />
                    </div>
                  }
                </div>
            </div>
          }
          <div className="small">
            {'*'}
            {this.props.generalTranslations.VATtext}
          </div>
        </div>
        {this.props.previewImageVisible &&
          <div className="previewImage">
              <div className="previewTitle">{this.props.generalTranslations.Preview}</div>
              <img
                className="preview"
                src="//thumblr.uniid.it/sitemedia/teamsport/teamsport-default-kit.jpg"
                alt="preview"
              />
              {this.props.costumizationToggleItems.unisport &&
                <img
                  className="unisport_logo"
                  src="//thumblr.uniid.it/sitemedia/teamsport/logo-2019.png"
                  alt="unisport logo"
                />
              }
          </div>
        }

        {this.props.alertShown.isOpen ?
          <AlertBox
            renderItem={alertMessage}
            msg={msg}
            toggleAlert={this.toggleAlert}
            handleCloseDiscountInfo={this.handleCloseDiscountInfo}
          />
          :
          null
        }
      </div>
    );
  }
}

const mapState = state => (
  {
    generalTranslations: state.generalTranslations,
    costumizationToggleItems: state.costumizationToggleItems,
    settings: state.settings,
    sizeCanContinue: state.sizeCanContinue,
    colorCanContinue: state.colorCanContinue,
    alerts: state.alerts,
    alertShown: state.alertShown,
    ageConfirmed: state.ageConfirmed,
    total: state.total,
    discount: state.settings.discount,
  }
);

const mapDispatch = dispatch => (
  {
    toggleAlert: () => dispatch({
      type: 'TOGGLE',
    }),
  }
);

export default connect(mapState, mapDispatch)(TotalContainer);
